<template>
  <UnopenedLeadCard @close="close" @open="open" :lead="lead">
    <div class="mt-5">
      Great news: for a limited time, this referral is <strong>FREE</strong>!
    </div>

    <div class="mt-5">
      During your trial period, grab as many leads as you want, to connect
      with potential customers.
    </div>

    <div class="mt-5">
      After your trial ends, a lead costs {{ $formatters.currency(lead.market_price_cents) }} 
      <em>(plus tax)</em>. Most of what we collect goes back to the person who referred
      you to support high-quality referrals.
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

export default {
  name: 'UnopenedLeadFreeForNow',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  },
}
</script>